<template>
  <v-container class="pa-0 ma-0 d-flex flex-column">
    <!-- Row 1 -->
    <v-row class="ma-0 pa-0">
      <v-col
        v-for="(item, index) in row1"
        :key="index"
        cols="12"
        sm="6"
        md="3"
        :class="['pa-2', index === 0 && 'pr-0', index === row1.length - 1 && 'pl-0']"
      >
        <v-card
          outlined
          :style="getIconName(item.title).bgColor"
          class="stat-cards pa-3 ma-0 d-flex flex-column"
        >
          <!-- title + icon -->
          <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
            <v-container class="pa-0 ma-0 d-flex flex-column">
              <v-card-text class="pa-0 ma-0 text-body-1">
                {{ item.title }}
              </v-card-text>
              <v-card-text class="pa-0 ma-0 text-body-2">
                {{ formatNumber(item.value) }} {{ $store.state.currency.name }}
              </v-card-text>
            </v-container>

            <v-sheet
              width="28"
              height="28"
              :color="getIconName(item.title).bgIcon"
              class="pa-0 ma-0 d-flex align-center justify-center"
            >
              <my-icon
                :name="getIconName(item.title).name"
                :width="14"
                :height="14"
                :stroke="getIconName(item.title).color"
                :fill="getIconName(item.title).color"
              />
            </v-sheet>
          </v-container>

          <!-- percent -->
          <v-container class="pa-0 ma-0 d-flex align-center mt-2">
            <v-icon size="14" :color="getPercentColor(item.trend)">
              {{ getPercentIcon(item.trend) }}
            </v-icon>

            <v-card-text
              class="pa-0 ma-0 pl-2 text-body-2"
              :style="{ color: getPercentColor(item.trend) }"
            >
              {{ item.percent }}٪
            </v-card-text>

            <v-card-text class="pa-0 ma-0 text-body-2">
              {{ item.compare }}
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  name: "DashboardStats",
  components: { MyIcon },
  data() {
    return {
      loading: false,
      categories: [],
    };
  },
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
    duration: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    totalCost() {
      return this.categories[0] || [];
    },

    stats() {
      const totalCard = {
        title: this.totalCost.name,
        value: this.totalCost.value,
        percent: this.totalCost.percent,
        trend: this.totalCost.trend,
        compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
      };
      const nextThree = this.categories.slice(1, 4).map((c) => ({
        title: c.name,
        value: c.value,
        percent: c.percent,
        trend: c.trend,
        compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
      }));

      return [totalCard, ...nextThree];
    },

    row1() {
      return this.stats.slice(0, 4);
    },
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.getPettyData(newVal);
      },
    },

    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getPettyData(newVal);
      },
    },
  },
  mounted() {
    this.getPettyData();
  },

  methods: {
    async getPettyData(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/petty-cost-by-group", {
          params: {
            type: 'bank_cash',
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data?.data?.costByGroup || [];
          app.categories = res.map((item) => ({
            name: item.account_name,
            value: Math.abs(Number(item.current)),
            percent: item.diffPercent,
            trend: item.trend,
          }));
        })
        .catch((error) => {
          console.error("compare sell and profit chart error:", error);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    formatNumber(value) {
      if (value === null || value === undefined) return "-";
      return this.$numberFormat(value);
    },

    getIconName(title) {
      if (title === this.totalCost.name) {
        return {
          name: "slice-icon",
          bgIcon: "#155DFC",
          color: "#fff",
          bgColor: { backgroundColor: "#2b80ff24" },
        };
      }

      return {
        name: "arrow-up",
        bgIcon: "#00A63E",
        color: "#fff",
        bgColor: { backgroundColor: "#00c95043" },
      };
    },

    getPercentColor(trend) {
      if (trend != null && trend == "increase") {
        return "#008236";
      }
      if (trend != null && trend == "decrease") {
        return "#C10007";
      }
      if (trend != null && trend == "none") {
        return "#a7a4a4ff";
      }
    },
    getPercentIcon(trend) {
      if (trend != null && trend == "increase") {
        return "mdi-arrow-top-right";
      }
      if (trend != null && trend == "decrease") {
        return "mdi-arrow-bottom-right";
      }
      if (trend != null && trend == "none") {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.stat-cards {
  width: 100%;
  border-radius: 12px !important;
  border: 1px solid #f3f4f6;
  backdrop-filter: blur(5px);
}
</style>
